import { Show } from "solid-js";

type Props = {
  score: number | null;
  size?: "xs" | "sm" | "md";
};

/**
 * AI-derived lead-score badge. Color reflects the band:
 * - 80+ success (hot)
 * - 50-79 warning (warm)
 * - 20-49 info (cool)
 * - 0-19 ghost (cold)
 *
 * Null score renders an empty span — callers usually want to suppress
 * the badge entirely when no score exists, but a stable wrapper makes
 * list-cell alignment easier.
 */
export function LeadScoreBadge(props: Props) {
  return (
    <Show when={props.score !== null}>
      <span
        class={`badge ${bandClass(props.score!)} ${
          props.size === "xs" ? "badge-xs" : props.size === "md" ? "" : "badge-sm"
        } font-mono`}
        title={bandLabel(props.score!)}
        aria-label={`AI lead score ${props.score}, ${bandLabel(props.score!)}`}
      >
        {props.score}
      </span>
    </Show>
  );
}

function bandClass(score: number): string {
  if (score >= 80) return "badge-success";
  if (score >= 50) return "badge-warning";
  if (score >= 20) return "badge-info";
  return "badge-ghost";
}

function bandLabel(score: number): string {
  if (score >= 80) return "hot";
  if (score >= 50) return "warm";
  if (score >= 20) return "cool";
  return "cold";
}
